import {
  Autocomplete,
  Button,
  Chip,
  FormControlLabel,
  // InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
// import SearchIcon from "@mui/icons-material/Search";
import EngagementIncentivesTabs from "./EngagementIncentivesTabs";
import { useEffect, useState } from "react";
import Page404 from "../../Page404/Page403";
import { selectUserData, selectUserToken } from "../../../features/userSlice";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import CancelIcon from "@mui/icons-material/Cancel";
import { Box } from "@mui/system";
import { setDataSetType } from "../../../features/engagementIncentivesSlice";
import { useDispatch } from "react-redux";
const EngagementIncentives = () => {
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const userToken = useSelector(selectUserToken);
  const [searchParams, setSearchParams] = useSearchParams();
  const [siteSelectionTrigger, setSiteSelectionTrigger] = useState(0);
  const SELECT_ALL_OPTION = { value: "select_all", label: "Select All" };
  const [selectedSites, setSelectedSites] = useState<any[]>([]);
  const siteOptions =
    userData?.data?.website_permissions?.map((siteObj: any) => {
      const uid = Object.keys(siteObj)[0]; // UID of the site
      const siteName = siteObj[uid].ui_site_name; // Site name
      return { uid, siteName }; // Return as an object with uid and siteName
    }) || [];
  const dataSetType = useSelector(
    (state: any) => state.engagementIncentives?.dataSetType
  );
  const navigate = useNavigate();
  const [selectedSiteUids, setSelectedSiteUids] = useState<string[]>([]);
  // State to store the selected site's UID
  const [showEngagementIncentivesTabs, setShowEngagementIncentivesTabs] =
    useState(false);
  const hasViewMonthlyBudgetPermission = CheckPermissions(
    userData?.data?.products?.paid_traffic,
    "advertising_accounts",
    "view_monthly_budgets"
  );

  const mappedSiteOptions =
    siteOptions.map((site: any) => ({
      value: site.uid,
      label: site.siteName,
    })) || [];

  const handleSelectSite = () => {
    setShowEngagementIncentivesTabs(true);
    if (selectedSiteUids.length > 0) {
      const updatedParams = new URLSearchParams(searchParams);

      // Remove the unwanted params
      updatedParams.delete("periodTab1");
      updatedParams.delete("startDateTab1");
      updatedParams.delete("endDateTab1");
      updatedParams.delete("periodTab2");
      updatedParams.delete("startDateTab2");
      updatedParams.delete("endDateTab2");
      updatedParams.delete("brandNameTab2");
      updatedParams.delete("brandNameTab3");
      updatedParams.delete("startDateTab3");
      updatedParams.delete("endDateTab3");
      updatedParams.delete("pagePerformanceByDayBrand");
      updatedParams.delete("pageBudgetControl");
      updatedParams.delete("pageClickData");

      updatedParams.set("selectedSites", selectedSiteUids.join(","));
      updatedParams.set("dataSetType", dataSetType);
      setSearchParams(updatedParams);
      setSiteSelectionTrigger((prev) => prev + 1);
    }
  };
  const handleSelectSites = (_: any, selectedValues: any[]) => {
    const isSelectAll = selectedValues.some(
      (opt) => opt.value === SELECT_ALL_OPTION.value
    );
    if (isSelectAll) {
      if (selectedSites.length === mappedSiteOptions.length) {
        setSelectedSites([]); // Deselect all
        setSelectedSiteUids([]); // Clear selected UIDs
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete("selectedSites");
        updatedParams.delete("tab");
        updatedParams.delete("dataSetType");
        setSearchParams(updatedParams);
      } else {
        const allSites = mappedSiteOptions;
        const allUids = allSites.map((site: any) => site.value);
        setSelectedSites(allSites);
        setSelectedSiteUids(allUids);

        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.set("selectedSites", allUids.join(","));
        setSearchParams(updatedParams);
      }
    } else {
      const uids = selectedValues.map((site) => site.value);
      setSelectedSites(selectedValues);
      setSelectedSiteUids(uids);

      const updatedParams = new URLSearchParams(searchParams);
      if (uids.length > 0) {
        updatedParams.set("selectedSites", uids.join(","));
      } else {
        updatedParams.delete("selectedSites");
        updatedParams.delete("tab");
        updatedParams.delete("dataSetType");
        setShowEngagementIncentivesTabs(false); // Also hide tabs when no sites selected
      }
      setSearchParams(updatedParams);
    }
  };
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  useEffect(() => {
    const siteUidsFromParams = searchParams.get("selectedSites");

    if (!siteUidsFromParams) {
      setSelectedSites([]);
      setSelectedSiteUids([]);
      setShowEngagementIncentivesTabs(false);
      return;
    }

    const uidArray = siteUidsFromParams.split(",");
    const selected = mappedSiteOptions.filter((site: any) =>
      uidArray.includes(site.value)
    );

    setSelectedSites(selected);
    setSelectedSiteUids(uidArray);

    if (isInitialLoad && uidArray.length > 0) {
      setShowEngagementIncentivesTabs(true);
      setSiteSelectionTrigger((prev) => prev + 1);
      setIsInitialLoad(false); // prevent re-trigger
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const urlDataSetType = searchParams.get("dataSetType");

    if (urlDataSetType) {
      dispatch(setDataSetType(urlDataSetType));
    } else {
      // Default to click_date
      dispatch(setDataSetType("action_date"));
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const selectedSitesParam = searchParams.get("selectedSites");
    const dataSetTypeParam = searchParams.get("dataSetType");

    if (!selectedSitesParam || !dataSetTypeParam) {
      // Redirect to clean URL
      setSelectedSites([]);
      setSelectedSiteUids([]);
      setShowEngagementIncentivesTabs(false);
      navigate("/paidTraffic/engagement_incentives", { replace: true });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {hasViewMonthlyBudgetPermission ? (
        <>
          <Paper sx={{ padding: "8px 16px", mb: 2 }}>
            {/* <Typography fontSize={24}>Engagement Incentives</Typography>
            <Typography sx={{ color: "#00000099", paddingBottom: "16px" }}>
              View, Edit and Analyze budgets in relation to the actual
              performance of incentivized traffic
            </Typography> */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              paddingBottom={2}
            >
              <Box>
                <Typography fontSize={24} sx={{ paddingBottom: "4px" }}>
                  Engagement Incentives
                </Typography>
                <Typography sx={{ color: "#00000099" }}>
                  View, Edit and Analyze budgets in relation to the actual
                  performance of incentivized traffic
                </Typography>
              </Box>
              <Box
                mt={{ xs: 2, sm: 0 }}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Box
                  sx={{
                    mr: 2,
                    whiteSpace: "nowrap",
                    color: "#000",
                    fontSize: "1rem",
                  }}
                >
                  Data set:
                </Box>
                <RadioGroup
                  row
                  name="dataset"
                  value={dataSetType}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    dispatch(setDataSetType(newValue));
                  }}
                  sx={{ display: "flex", flexDirection: "row" }}
                >
                  <FormControlLabel
                    value="action_date"
                    control={<Radio size="small" color="secondary" inputProps={
                      { "data-tracker": "394" } as Record<string, any>
                    } />}
                    label="Action Date"
                  />
                  <FormControlLabel
                    value="click_date"
                    control={<Radio size="small" color="secondary" inputProps={
                      { "data-tracker": "395" } as Record<string, any>
                    } />}
                    label="Click Date"
                  />
                </RadioGroup>
              </Box>
            </Box>
            <Grid container mt={0} columnSpacing={3} mb={1}>
              <Grid size={10}>
                <Autocomplete
                  multiple
                  sx={{ width: "100%" }}
                  options={[SELECT_ALL_OPTION, ...mappedSiteOptions]}
                  value={selectedSites}
                  getOptionLabel={(option: any) => option.label}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.value === value?.value
                  }
                  onChange={(event, newValue) => {
                    handleSelectSites(event, newValue);
                  }}
                  onInputChange={(_, __, reason) => {
                    if (reason === "clear") {
                      setShowEngagementIncentivesTabs(false); // Set to false when the clear button (cross) is clicked
                      const updatedParams = new URLSearchParams(searchParams);
                      updatedParams.delete("tab");
                      updatedParams.delete("selectedSites"); // Optional: clear selected sites from URL too
                      updatedParams.delete("dataSetType");
                      setSearchParams(updatedParams);
                    }
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option: any, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option?.value}
                        label={option?.label}
                        sx={{
                          backgroundColor: "#7B1FA2",
                          color: "#ffffff",
                          height: "24px",
                        }}
                        deleteIcon={
                          <CancelIcon
                            sx={{
                              color: "rgba(255, 255, 255, 0.8) !important",
                              fontSize: "16px !important",
                            }}
                          />
                        }
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Website"
                      placeholder="Search site name or choose from the list"
                      color="secondary"
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        backgroundColor:
                          option.value === SELECT_ALL_OPTION.value
                            ? "#9C27B00A"
                            : "inherit",
                        color:
                          option.value === SELECT_ALL_OPTION.value
                            ? "#9C27B0"
                            : "inherit",
                        fontWeight:
                          option.value === SELECT_ALL_OPTION.value
                            ? "500"
                            : "normal",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#9C27B00A";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          option.value === SELECT_ALL_OPTION.value
                            ? "#9C27B00A"
                            : "inherit";
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                  size="small"
                />
              </Grid>
              <Grid size={2}>
                <Button
                  variant="contained"
                  disabled={selectedSiteUids.length === 0}
                  fullWidth
                  size="large"
                  color="secondary"
                  sx={{ py: "7px" }}
                  onClick={handleSelectSite}
                  data-tracker="188"
                >
                  SELECT SITE
                </Button>
              </Grid>
            </Grid>
          </Paper>
          {showEngagementIncentivesTabs && searchParams.get("dataSetType") && (
            <Paper sx={{ padding: "8px 16px" }}>
              <EngagementIncentivesTabs
                userToken={userToken}
                selectedSiteUids={selectedSiteUids}
                siteSelectionTrigger={siteSelectionTrigger}
              />
            </Paper>
          )}
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default EngagementIncentives;
